import { render, staticRenderFns } from "./step-layout.vue?vue&type=template&id=99b809c8&scoped=true&"
var script = {}
import style0 from "./step-layout.vue?vue&type=style&index=0&id=99b809c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b809c8",
  null
  
)

export default component.exports